export default {
  computed: {
    /**
     * Determine if user is an admin.
     *
     * @return bool
     */
    userIsAdmin () {
      return this.user.role === 'admin' || this.user.role === 'regional-admin' || this.user.role === 'super-regional-admin' || this.user.role === 'restricted-admin' || this.user.role === 'reporting-admin'
    },

    canEditAdmin () {
      return this.$userIsAdmin && (!this.$userIsRestrictedAdmin || this.user.id === this.$user.id)
    },

    /**
     * Determine if user is a talent.
     *
     * @return bool
     */
    userIsTalent () {
      return this.user.role === 'talent'
    },

    /**
     * Determine if user is a client.
     *
     * @return bool
     */
    userIsClient () {
      return this.user.role === 'client'
    },

    /**
     * Determine if user is a manager.
     *
     * @return bool
     */
    userIsManager () {
      return this.user.role === 'manager'
    },

    /**
     * Determine if user is a manager.
     *
     * @return bool
     */
    userIsMasterManager () {
      return this.user.role === 'manager' &&
        (this.user.parent_id === null || this.user.parent_id === undefined)
    },

    /**
     * Determine if user is a manager.
     *
     * @return bool
     */
    userIsStaffManager () {
      return this.user.role === 'manager' &&
        this.user.parent_id !== null
    },

    /**
     * Determine if user is activated.
     *
     * @return bool
     */
    userIsActivated () {
      return this.user.status === 'active'
    },

    /**
     * Determine if user is pending activation.
     *
     * @return bool
     */
    userIsPending () {
      return this.user.status === 'pending'
    },

    /**
     * Determine if user is not activated.
     *
     * @return bool
     */
    userIsNotActivated () {
      return this.user.status !== 'active'
    },

    /**
     * Determine if user is unverified.
     *
     * @return bool
     */
    userIsUnverified () {
      return this.user.email_verified === false
    },

    /**
     * Determine if user is verified.
     *
     * @return bool
     */
    userIsVerified () {
      return this.user.email_verified === true
    },

    /**
     * Determine if user is not deleted.
     *
     * @return bool
     */
    userNotDeleted () {
      return this.user.deleted_at === null
    },

    /**
     * Determine if user is deleted.
     *
     * @return bool
     */
    userIsDeleted () {
      return this.user.deleted_at !== null
    },

    /**
     * Get the original profile image URL.
     *
     * This is primarily used for editing the profile image so we can re-crop it if necessary.
     *
     * @return string|null
     */
    userProfileImageOriginalUrl () {
      if (this.user.profile_image_hash) {
        return this.user.original_profile_image_url
      }

      return null
    },

    /**
     * Get the users cropped profile image URL.
     *
     * This will default to an default image.
     *
     * @return string
     */
    userProfileImageUrl () {
      return this.user.profile_image_url
    },

    /**
     * Get the users role as a displayable string.
     *
     * @return string
     */
    userDisplayRole () {
      if (this.userIsAdmin) {
        return 'Admin'
      } else if (this.userIsTalent) {
        return 'Talent'
      } else if (this.userIsClient) {
        return 'Client'
      } else if (this.userIsStaffManager) {
        return 'Booking Agent'
      } else if (this.userIsManager) {
        return 'Manager'
      }
    }
  }
}
